
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 15.75a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm0-6.75A2.25 2.25 0 1018 9a2.25 2.25 0 00-4.5 0zM6.75 2.25a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm6.75 0a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM6.75 9a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM0 9a2.25 2.25 0 104.5 0A2.25 2.25 0 000 9zm0 6.75a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm6.75 0a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM0 2.25a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0z","fill":"#263238"}})])
          )
        }
      }
    